import React, { useEffect } from "react";
import {BONUSSUMMERY_STRINGS} from "./Strings";
const Tooltip = ({ tooltipBox, tooltipArrow, from, text, text2, ...rest }) => {
  const [show, setShow] = React.useState(false);
  const handleShow = () => {
    setShow(false);
  };
  const showClick = () => {
    const tooltipShowClickEvent = new Event('tool_tip_show_click');
    dispatchEvent(tooltipShowClickEvent);
    setTimeout(() => {
      setShow(false);
    }, 5000);

    setTimeout(() => {
      setShow(true);
    }, 20);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleShow);
    window.addEventListener("tool_tip_show_click", handleShow);
    window.addEventListener("handleOutSideClick", handleShow);
    return () => {
      setShow(false);
    };
  }, []);

  return (
    <div className="tooltip-container">
     
      <div className={show ? `${tooltipBox} visible` : tooltipBox}>
        {from === ""?<span style={{color:"#032416",fontSize:"0.9em"}} className="text-bold center tc">{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_WAGERING_TV}</span>:undefined}
        {text }
        <p>{text2?text2:""}</p>
       
        <span
          className={`${tooltipArrow}`}
        />
      </div>
      <div onClick={showClick} {...rest}>
        {/* {{children}} */}
      </div>

    </div>
  );
};

export default Tooltip;